import { render } from "./ProgressbarView.vue?vue&type=template&id=a3ffafd0"
import script from "./ProgressbarView.vue?vue&type=script&lang=js"
export * from "./ProgressbarView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__